import { type GridApi, type IRowNode } from "ag-grid-community"

import { getPricingRowKey, pricingCalc } from "../../utils"

import { type PricingGridRow } from "./types"
import { refreshRowsInPlace } from "./utils"

import { type PriceChangeItem } from "@/graphql/codegen/graphql"

interface ColHandlerParams {
  api: GridApi<PricingGridRow>
  node: IRowNode<PricingGridRow>
  rowKey: string
  modifiedRows: Set<string>
}

type ColHandler = (params: ColHandlerParams) => void

const handleNewPriceChange: ColHandler = ({ api, node }) => {
  if (!node.data) return

  const { acceptedCost, newPrice } = node.data

  node.data.newMargin = pricingCalc.newMargin({ newPrice, acceptedCost })
  api.refreshCells({ rowNodes: [node], columns: ["newMargin"] })
}

const createSpannedColHandler =
  (columnId: keyof PriceChangeItem): ColHandler =>
  ({ api, node, modifiedRows }) => {
    if (!node.data) return
    const editedItem = node.data.item
    const rowNodes: IRowNode<PricingGridRow>[] = []
    api.forEachNode((rowNode) => {
      if (rowNode.data?.item !== editedItem) return
      rowNodes.push(rowNode)
      if (rowNode.data) modifiedRows.add(getPricingRowKey(rowNode.data))
    })
    api.refreshCells({ rowNodes, columns: [columnId], force: true })
    refreshRowsInPlace(rowNodes)
  }

export const COL_HANDLERS: Partial<Record<string, ColHandler>> = {
  newPrice: handleNewPriceChange,
  bb: createSpannedColHandler("billBack"),
  changeNote: createSpannedColHandler("changeNote"),
  effectiveDate: createSpannedColHandler("effectiveDate"),
  expirationDate: createSpannedColHandler("expirationDate"),
}
